import {
  useQueryStates,
  parseAsArrayOf,
  parseAsInteger,
  createParser,
} from 'nuqs'
import { format, isValid, parse, startOfWeek } from 'date-fns'

const parseAsLocalDate = createParser<Date>({
  parse(queryValue: string) {
    const parsedDate = parse(queryValue, 'yyyy-MM-dd', new Date())
    if (!isValid(parsedDate)) {
      return null
    }
    return parsedDate
  },
  serialize(value: Date) {
    return format(value, 'yyyy-MM-dd')
  },
  eq(a: Date, b: Date) {
    return a.getTime() === b.getTime()
  },
})

export function useVndlyTimesheetFilterQueryState(defaultCompanyIds: number[]) {
  const defaultDateTo = new Date()
  const defaultDateFrom = startOfWeek(defaultDateTo, { weekStartsOn: 0 })

  return useQueryStates(
    {
      companyIds: parseAsArrayOf(parseAsInteger).withDefault(defaultCompanyIds),
      dateFrom: parseAsLocalDate.withDefault(defaultDateFrom),
      dateTo: parseAsLocalDate.withDefault(defaultDateTo),
    },
    {
      urlKeys: {
        companyIds: 'company-ids',
        dateFrom: 'date-from',
        dateTo: 'date-to',
      },
    }
  )
}
